export default "__VITE_ASSET__CE63nnei__"